import React from 'react';

const STATUS_MAP = {
  in_stock:   { label: 'In Stock',    cls: 'pill-stock' },
  on_hold:    { label: 'On Hold',     cls: 'pill-hold' },
  in_transit: { label: 'In Transit',  cls: 'pill-transit' },
  received:   { label: 'Received',    cls: 'pill-recv' },
  on_memo:    { label: 'On Memo',     cls: 'pill-memo' },
  invoiced:   { label: 'Invoiced',    cls: 'pill-sold' },
  paid:       { label: 'Paid',        cls: 'pill-paid' },
  unpaid:     { label: 'Unpaid',      cls: 'pill-unpaid' },
  overdue:    { label: 'Overdue',     cls: 'pill-overdue' },
  active:     { label: 'Active',      cls: 'pill-stock' },
  returned:   { label: 'Returned',    cls: 'pill-sold' },
  converted:  { label: 'Converted',   cls: 'pill-transit' },
  completed:  { label: 'Completed',   cls: 'pill-stock' },
};

export default function StatusPill({ status, label: overrideLabel }) {
  const cfg = STATUS_MAP[status] || { label: overrideLabel || status, cls: 'pill-sold' };
  return <span className={`pill ${cfg.cls}`}>{overrideLabel || cfg.label}</span>;
}
